

// import React, { useState } from "react";
// import styled, { keyframes } from "styled-components";
// import { Fade } from "react-awesome-reveal";
// import { 
//   Sparkles, 
//   ArrowRight, 
//   CheckCircle2, 
//   MapPin, 
//   ShieldCheck, 
//   TrendingUp, 
//   FileText, 
//   Maximize2,
//   Layers,
//   Award,
//   Video as VideoIcon
// } from "lucide-react";
// import v4 from '../images/v4.mp4'

// // Animations using gold highlights
// const flashAttention = keyframes`
//   0%, 100% {
//     transform: scale(1);
//     box-shadow: 0 0 0 0 rgba(212, 175, 55, 0.7);
//   }
//   50% {
//     transform: scale(1.03);
//     box-shadow: 0 0 0 10px rgba(212, 175, 55, 0);
//   }
// `;

// const textGlow = keyframes`
//   0%, 100% { opacity: 1; }
//   50% { opacity: 0.5; }
// `;

// // Styled Components (Light Theme with Navy/Gold, max padding/gap/margin strictly 10px)
// const PageWrapper = styled.div`
//   background-color: #f8fafc;
//   color: #0a192f;
//   min-height: 100vh;
//   font-family: inherit;
// `;

// const Section = styled.section`
//   padding: 10px;
//   position: relative;
//   overflow: hidden;
// `;

// const Container = styled.div`
//   max-width: 1200px;
//   margin: 0 auto;
//   display: flex;
//   flex-direction: column;
//   gap: 10px;
// `;

// const HeroCard = styled.div`
//   position: relative;
//   border-radius: 10px;
//   overflow: hidden;
//   border: 2px solid #d4af37;
//   box-shadow: 0 6px 15px rgba(212, 175, 55, 0.2);
//   background: linear-gradient(
//       rgba(255, 255, 255, 0.92), 
//       rgba(248, 250, 252, 0.96)
//     ),
//     url("https://images.unsplash.com/photo-1590381105924-c72589b9ef3f?auto=format&fit=crop&w=1920&q=80") 
//     no-repeat center center/cover;
//   padding: 10px;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   text-align: center;
//   gap: 10px;
// `;

// const AlertBadge = styled.div`
//   display: inline-flex;
//   align-items: center;
//   gap: 6px;
//   background-color: #0a192f;
//   color: #d4af37;
//   padding: 4px 10px;
//   font-size: 0.8rem;
//   font-weight: 900;
//   text-transform: uppercase;
//   letter-spacing: 1.5px;
//   border-radius: 50px;
//   animation: ${flashAttention} 1.5s infinite;

//   span {
//     animation: ${textGlow} 1s infinite;
//   }
// `;

// const Title = styled.h1`
//   font-size: clamp(1.6rem, 3.5vw, 2.4rem);
//   font-weight: 900;
//   color: #0a192f;
//   line-height: 1.2;
//   margin: 0;

//   span {
//     color: #b89728;
//     text-decoration: underline;
//   }
// `;

// const Description = styled.p`
//   font-size: 0.95rem;
//   color: #475569;
//   font-weight: 600;
//   max-width: 700px;
//   line-height: 1.5;
//   margin: 0;
// `;

// const VideoContainer = styled.div`
//   width: 100%;
//   border-radius: 8px;
//   overflow: hidden;
//   border: 1px solid rgba(212, 175, 55, 0.5);
//   box-shadow: 0 4px 12px rgba(10, 25, 47, 0.1);
//   background: #0a192f;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   margin-top: 5px;

//   video {
//     width: 100%;
//     max-height: 400px;
//     object-fit: cover;
//     display: block;
//     border-radius: 6px;
//   }
// `;

// const GridBox = styled.div`
//   display: grid;
//   grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
//   gap: 10px;
//   width: 100%;
// `;

// const DetailCard = styled.div`
//   background: #ffffff;
//   border: 1px solid rgba(212, 175, 55, 0.4);
//   border-radius: 10px;
//   padding: 10px;
//   display: flex;
//   flex-direction: column;
//   gap: 10px;
//   text-align: left;
//   box-shadow: 0 4px 10px rgba(10, 25, 47, 0.05);
// `;

// const CardHeading = styled.h3`
//   font-size: 1.1rem;
//   font-weight: 800;
//   color: #0a192f;
//   margin: 0;
//   display: flex;
//   align-items: center;
//   gap: 6px;
// `;

// const ListGroup = styled.ul`
//   list-style: none;
//   padding: 0;
//   margin: 0;
//   display: flex;
//   flex-direction: column;
//   gap: 8px;

//   li {
//     display: flex;
//     align-items: center;
//     gap: 6px;
//     font-size: 0.85rem;
//     color: #475569;
//     font-weight: 600;

//     svg {
//       color: #b89728;
//       flex-shrink: 0;
//     }
//   }
// `;

// const PricingTable = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: 8px;
//   width: 100%;
// `;

// const PriceRow = styled.div`
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   background: #f8fafc;
//   padding: 8px 10px;
//   border-radius: 6px;
//   border: 1px solid #e2e8f0;
//   font-size: 0.85rem;
//   font-weight: 700;
//   color: #0a192f;

//   span {
//     color: #b89728;
//   }
// `;

// const FormWrapper = styled.form`
//   display: flex;
//   flex-direction: column;
//   gap: 10px;
//   width: 100%;
//   max-width: 600px;
//   margin: 0 auto;
//   background: #f8fafc;
//   border: 1px solid #b89728;
//   border-radius: 10px;
//   padding: 10px;
// `;

// const InputField = styled.input`
//   padding: 8px 10px;
//   border-radius: 6px;
//   border: 1px solid #cbd5e1;
//   background: #ffffff;
//   color: #0a192f;
//   font-size: 0.9rem;
//   outline: none;
//   width: 100%;
//   box-sizing: border-box;

//   &:focus {
//     border-color: #0a192f;
//   }
// `;

// const TextArea = styled.textarea`
//   padding: 8px 10px;
//   border-radius: 6px;
//   border: 1px solid #cbd5e1;
//   background: #ffffff;
//   color: #0a192f;
//   font-size: 0.9rem;
//   outline: none;
//   width: 100%;
//   resize: vertical;
//   min-height: 80px;
//   box-sizing: border-box;

//   &:focus {
//     border-color: #0a192f;
//   }
// `;

// const ActionButton = styled.button`
//   display: inline-flex;
//   align-items: center;
//   justify-content: center;
//   gap: 6px;
//   background-color: #0a192f;
//   color: #ffffff;
//   padding: 8px 10px;
//   font-size: 0.95rem;
//   font-weight: 800;
//   border-radius: 50px;
//   border: none;
//   cursor: pointer;
//   text-decoration: none;
//   transition: all 0.3s ease;
//   box-shadow: 0 4px 12px rgba(10, 25, 47, 0.2);
//   width: 100%;

//   &:hover {
//     background-color: #b89728;
//     color: #0a192f;
//     transform: translateY(-2px);
//   }
// `;

// const SuccessMessage = styled.div`
//   background: rgba(212, 175, 55, 0.15);
//   color: #0a192f;
//   padding: 8px 10px;
//   border-radius: 6px;
//   font-weight: 700;
//   text-align: center;
//   font-size: 0.85rem;
//   border: 1px solid #b89728;
// `;

// const InnovationCityDetailPage = () => {
//   const [submitted, setSubmitted] = useState(false);
//   const [formData, setFormData] = useState({ name: "", email: "", phone: "", plotSize: "500sqm" });

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (formData.name && formData.email) {
//       setSubmitted(true);
//     }
//   };

//   return (
//     <PageWrapper>
//       <Section>
//         <Container>
//           <Fade direction="up" triggerOnce>
//             <HeroCard>
//               <AlertBadge>
//                 <Sparkles size={16} />
//                 <span>Selling Now • Complete Details</span>
//               </AlertBadge>

//               <Title>
//                 Innovation City <span>Apo, Abuja</span>
//               </Title>

//               <Description>
//                 Welcome to Innovation City Apo, Abuja—a premier master-planned community engineered for high return on investment, rapid infrastructural development, and absolute title security.
//               </Description>
//             </HeroCard>
//           </Fade>

//           <Fade direction="up" delay={50} triggerOnce>
//             <DetailCard>
//               {/* <CardHeading style={{ justifyContent: "center" }}>
//                 <VideoIcon size={18} /> Central City Aerial Showcase
//               </CardHeading> */}
//               <VideoContainer>
//                 <video 
//                   controls 
//                   autoPlay 
//                   muted 
//                   loop 
//                   playsInline
//                   poster="https://images.unsplash.com/photo-1590381105924-c72589b9ef3f?auto=format&fit=crop&w=1920&q=80"
//                 >
//                   <source src={v4} type="video/mp4" />
//                   Your browser does not support the video tag.
//                 </video>
//               </VideoContainer>
//             </DetailCard>
//           </Fade>

//           <GridBox>
//             <Fade direction="up" delay={100} triggerOnce>
//               <DetailCard>
//                 <CardHeading>
//                   <MapPin size={18} /> Location & Accessibility
//                 </CardHeading>
//                 <ListGroup>
//                   <li><CheckCircle2 size={14} /> Situated in the fast-growing Apo corridor, Abuja.</li>
//                   <li><CheckCircle2 size={14} /> 15 minutes drive from major commercial districts.</li>
//                   <li><CheckCircle2 size={14} /> Excellent road networks and topography.</li>
//                   <li><CheckCircle2 size={14} /> Close proximity to established residential estates.</li>
//                 </ListGroup>
//               </DetailCard>
//             </Fade>

//             <Fade direction="up" delay={200} triggerOnce>
//               <DetailCard>
//                 <CardHeading>
//                   <ShieldCheck size={18} /> Title & Verification
//                 </CardHeading>
//                 <ListGroup>
//                   <li><CheckCircle2 size={14} /> Verified C of O (Certificate of Occupancy).</li>
//                   <li><CheckCircle2 size={14} /> 100% Free from government acquisition.</li>
//                   <li><CheckCircle2 size={14} /> Secure land banking with immediate deed of assignment.</li>
//                   <li><CheckCircle2 size={14} /> Fully cleared layout maps and documentation.</li>
//                 </ListGroup>
//               </DetailCard>
//             </Fade>

//             <Fade direction="up" delay={300} triggerOnce>
//               <DetailCard>
//                 <CardHeading>
//                   <Layers size={18} /> Available Plot Sizes
//                 </CardHeading>
//                 <ListGroup>
//                   <li><Maximize2 size={14} /> Residential Plot: 500sqm (Standard Family Unit)</li>
//                   <li><Maximize2 size={14} /> Residential Plot: 300sqm (Compact / Terrace Unit)</li>
//                   <li><Maximize2 size={14} /> Commercial Plot: 1,000sqm (Plaza & Business Hub)</li>
//                   <li><CheckCircle2 size={14} /> Immediate physical allocation upon completion.</li>
//                 </ListGroup>
//               </DetailCard>
//             </Fade>

//             <Fade direction="up" delay={400} triggerOnce>
//               <DetailCard>
//                 <CardHeading>
//                   <TrendingUp size={18} /> Pricing & Investment ROI
//                 </CardHeading>
//                 <PricingTable>
//                   <PriceRow>
//                     <span>300sqm Residential</span> ₦15,000,000
//                   </PriceRow>
//                   <PriceRow>
//                     <span>500sqm Residential</span> ₦25,000,000
//                   </PriceRow>
//                   <PriceRow>
//                     <span>1000sqm Commercial</span> ₦60,000,000
//                   </PriceRow>
//                 </PricingTable>
//               </DetailCard>
//             </Fade>
//           </GridBox>

//           <Fade direction="up" delay={500} triggerOnce>
//             <DetailCard style={{ textAlign: "center" }}>
//               <CardHeading style={{ justifyContent: "center" }}>
//                 <Award size={18} /> Infrastructure & Amenities
//               </CardHeading>
//               <GridBox style={{ gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", marginTop: "10px" }}>
//                 <ListGroup>
//                   <li><CheckCircle2 size={14} /> Perimeter Fencing</li>
//                   <li><CheckCircle2 size={14} /> Gatehouse & Security</li>
//                 </ListGroup>
//                 <ListGroup>
//                   <li><CheckCircle2 size={14} /> Central Water System</li>
//                   <li><CheckCircle2 size={14} /> Electricity & Transformers</li>
//                 </ListGroup>
//                 <ListGroup>
//                   <li><CheckCircle2 size={14} /> Interlocked Access Roads</li>
//                   <li><CheckCircle2 size={14} /> Drainage & Green Areas</li>
//                 </ListGroup>
//               </GridBox>
//             </DetailCard>
//           </Fade>

//           <Fade direction="up" delay={600} triggerOnce>
//             <DetailCard>
//               <CardHeading style={{ justifyContent: "center" }}>
//                 <FileText size={18} /> Schedule an Inspection or Secure a Plot
//               </CardHeading>
              
//               {submitted ? (
//                 <SuccessMessage>
//                   Thank you! Your inspection/reservation request has been received. Our team will contact you shortly.
//                 </SuccessMessage>
//               ) : (
//                 <FormWrapper onSubmit={handleSubmit}>
//                   <InputField 
//                     type="text" 
//                     placeholder="Full Name" 
//                     value={formData.name}
//                     onChange={(e) => setFormData({...formData, name: e.target.value})}
//                     required 
//                   />
//                   <InputField 
//                     type="email" 
//                     placeholder="Email Address" 
//                     value={formData.email}
//                     onChange={(e) => setFormData({...formData, email: e.target.value})}
//                     required 
//                   />
//                   <InputField 
//                     type="tel" 
//                     placeholder="Phone Number" 
//                     value={formData.phone}
//                     onChange={(e) => setFormData({...formData, phone: e.target.value})}
//                     required 
//                   />
//                   <InputField 
//                     as="select" 
//                     value={formData.plotSize}
//                     onChange={(e) => setFormData({...formData, plotSize: e.target.value})}
//                   >
//                     <option value="300sqm">300sqm Residential</option>
//                     <option value="500sqm">500sqm Residential</option>
//                     <option value="1000sqm">1000sqm Commercial</option>
//                   </InputField>
//                   <TextArea 
//                     placeholder="Additional notes or preferred inspection date/time..."
//                   ></TextArea>
//                   <ActionButton type="submit">
//                     Submit Request <ArrowRight size={16} />
//                   </ActionButton>
//                 </FormWrapper>
//               )}
//             </DetailCard>
//           </Fade>
//         </Container>
//       </Section>
//     </PageWrapper>
//   );
// };

// export default InnovationCityDetailPage;





import React, { useState } from "react";
import styled from "styled-components";
import { Fade } from "react-awesome-reveal";
import { ArrowLeft, CheckCircle2, ShieldCheck, MapPin, Building, Ruler, Tag, PhoneCall } from "lucide-react";
import apoimg from '../images/ap7.jpeg'


const DetailSection = styled.section`
  padding: 40px 16px;
  background-color: #f8fafc;
  min-height: 100vh;
  font-family: 'Plus Jakarta Sans', system-ui, -apple-system, sans-serif;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const BackButton = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #2563eb;
  font-weight: 700;
  text-decoration: none;
  margin-bottom: 24px;
  transition: transform 0.2s;

  &:hover {
    transform: translateX(-4px);
  }
`;

const HeaderWrapper = styled.div`
  text-align: center;
  margin-bottom: 30px;

  h1 {
    font-size: clamp(2rem, 4vw, 2.8rem);
    font-weight: 900;
    color: #0a192f;
    margin: 0 0 8px 0;

    span {
      color: #2563eb;
    }
  }

  p {
    font-size: 1.05rem;
    color: #64748b;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }
`;

const MainContentGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
  align-items: center;

  @media screen and (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

const ImageDisplayCard = styled.div`
  background: #ffffff;
  border-radius: 14px;
  overflow: hidden;
  border: 2px solid #e2e8f0;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05);
  padding: 12px;

  img {
    width: 100%;
    height: auto;
    border-radius: 8px;
    object-fit: cover;
    display: block;
  }
`;

const InfoCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const DescriptionBox = styled.div`
  background: #ffffff;
  padding: 20px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);

  h3 {
    font-size: 1.2rem;
    font-weight: 800;
    color: #0a192f;
    margin-bottom: 8px;
  }

  p {
    font-size: 0.95rem;
    color: #334155;
    line-height: 1.6;
    margin: 0;
  }
`;

// Pricing Table extracted directly from the image header
const TableSection = styled.div`
  margin-top: 40px;
  background: #ffffff;
  border-radius: 14px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05);
  overflow: hidden;

  h2 {
    background: #0a192f;
    color: #ffffff;
    padding: 16px 20px;
    margin: 0;
    font-size: 1.3rem;
    font-weight: 800;
    text-align: center;
    letter-spacing: 0.5px;
  }
`;

const ResponsiveTableWrapper = styled.div`
  overflow-x: auto;
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  text-align: center;

  th, td {
    padding: 14px 12px;
    border-bottom: 1px solid #e2e8f0;
  }

  th {
    background-color: #f1f5f9;
    color: #1e293b;
    font-size: 0.85rem;
    font-weight: 800;
    text-transform: uppercase;
  }

  td {
    font-size: 0.95rem;
    color: #334155;
    font-weight: 600;
  }

  tr:hover {
    background-color: #f8fafc;
  }

  .price-tag {
    color: #2563eb;
    font-weight: 900;
  }
`;

const ContactActionContainer = styled.div`
  margin-top: 30px;
  display: flex;
  justify-content: center;
  gap: 16px;
  flex-wrap: wrap;
`;

const PrimaryButton = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background-color: #2563eb;
  color: #ffffff;
  padding: 12px 24px;
  border-radius: 50px;
  font-weight: 800;
  font-size: 1rem;
  text-decoration: none;
  box-shadow: 0 4px 14px rgba(37, 99, 235, 0.35);
  transition: all 0.3s ease;

  &:hover {
    background-color: #1d4ed8;
    transform: translateY(-2px);
  }
`;

const SecondaryButton = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background-color: #0a192f;
  color: #ffffff;
  padding: 12px 24px;
  border-radius: 50px;
  font-weight: 800;
  font-size: 1rem;
  text-decoration: none;
  box-shadow: 0 4px 14px rgba(10, 25, 47, 0.3);
  transition: all 0.3s ease;

  &:hover {
    background-color: #1e293b;
    transform: translateY(-2px);
  }
`;

// Property Data extracted accurately from the image
const apoHouseTypes = [
  { type: "Terrace", size: "170 sqm", price: "₦10,000,000" },
  { type: "Semi Detach", size: "250 sqm", price: "₦15,000,000" },
  { type: "Penthouse", size: "450 sqm", price: "₦26,000,000" },
  { type: "Lux Duplex", size: "600 sqm", price: "₦35,000,000" },
  { type: "Mansion", size: "850 sqm", price: "₦50,000,000" },
  { type: "Blocks of Flat", size: "1,200 sqm", price: "₦70,000,000" },
];

const InnovationCityDetails = () => {
  return (
    <DetailSection>
      <Container>
        <BackButton href="/">
          <ArrowLeft size={18} /> Back to Home
        </BackButton>

        <Fade direction="down" triggerOnce>
          <HeaderWrapper>
            <h1>Innovation City <span>Apo, Abuja</span></h1>
            <p><MapPin size={16} color="#2563eb" /> Prime Real Estate Investment & Housing Options</p>
          </HeaderWrapper>
        </Fade>

        <MainContentGrid>
          <Fade direction="left" triggerOnce>
            <ImageDisplayCard>
              {/* Using the user's provided image attachment */}
              <img src={apoimg} alt="Innovation City Apo Official Layout and Prices" />
            </ImageDisplayCard>
          </Fade>

          <Fade direction="right" triggerOnce>
            <InfoCard>
              <DescriptionBox>
                <h3>Project Overview</h3>
                <p>
                  Innovation City Apo offers state-of-the-art residential and commercial developments tailored for high return on investment. Designed with ultra-modern architecture, superior structural integrity, and fully serviced layouts situated in a fast-growing neighborhood of Abuja.
                </p>
              </DescriptionBox>

              <DescriptionBox>
                <h3>Why Invest Here?</h3>
                <p>
                  • Rapidly developing economic corridor in Apo, Abuja.<br />
                  • Flexible payment terms structured for smart investors.<br />
                  • Guaranteed high capital appreciation and instant allocation.
                </p>
              </DescriptionBox>
            </InfoCard>
          </Fade>
        </MainContentGrid>

        <Fade direction="up" triggerOnce>
          <TableSection>
            <h2>Official House Types, Sizes & Pricing Catalog</h2>
            <ResponsiveTableWrapper>
              <StyledTable>
                <thead>
                  <tr>
                    <th>House Type / Category</th>
                    <th>Plot / Size (SQM)</th>
                    <th>Official Price</th>
                  </tr>
                </thead>
                <tbody>
                  {apoHouseTypes.map((item, index) => (
                    <tr key={index}>
                      <td><strong>{item.type}</strong></td>
                      <td>{item.size}</td>
                      <td className="price-tag">{item.price}</td>
                    </tr>
                  ))}
                </tbody>
              </StyledTable>
            </ResponsiveTableWrapper>
          </TableSection>
        </Fade>

        <ContactActionContainer>
          <PrimaryButton href="tel:+2348121886498">
            <PhoneCall size={18} /> Call Sales Representative
          </PrimaryButton>
          <SecondaryButton href="https://wa.me/2348121886498" target="_blank" rel="noopener noreferrer">
            Chat on WhatsApp for Allocation
          </SecondaryButton>
        </ContactActionContainer>
      </Container>
    </DetailSection>
  );
};

export default InnovationCityDetails;